import React from 'react';
import { MatchRoutes } from 'services/route';
import { appRoutes } from 'routes';
import { normalizeRoutes } from 'services/route/normalize-routes.service';

function Bootstrap() {
  return <MatchRoutes routes={normalizeRoutes(appRoutes, '/')} />;
}

export default Bootstrap;
